import script from "./SogPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SogPage.vue?vue&type=script&setup=true&lang=ts"

import "./SogPage.vue?vue&type=style&index=0&id=b818ef84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b818ef84"]])

export default __exports__